import { render, staticRenderFns } from "./MovementItem.vue?vue&type=template&id=70f16fe6&scoped=true&"
import script from "./MovementItem.vue?vue&type=script&lang=js&"
export * from "./MovementItem.vue?vue&type=script&lang=js&"
import style0 from "./MovementItem.vue?vue&type=style&index=0&id=70f16fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f16fe6",
  null
  
)

export default component.exports